import { render, staticRenderFns } from "./StorageSpaces.vue?vue&type=template&id=3f342c28&"
import script from "./StorageSpaces.vue?vue&type=script&lang=js&"
export * from "./StorageSpaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports